import { render, staticRenderFns } from "./CfForm.vue?vue&type=template&id=46fd4baf"
import script from "./CfForm.vue?vue&type=script&lang=ts"
export * from "./CfForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports